module.exports = __webpack_public_path__ + "img/gongzuotai.90a4d6b5.png";